import AuditQuestionActivities from 'stores/AuditQuestionActivities';
import { UuidableName } from 'utils/api/types';
import { EntityModules } from 'core/constants';

// The `?tab=` URL contract. The drawer passes these as explicit tab values, so display order is free to differ.
export enum AuditQuestionDrawerTab {
  Activity = 0,
  Tasks = 1,
  LinkedItems = 2,
}

export type AuditQuestionDrawerProps = {
  activities: AuditQuestionActivities;
  questionKey: string;
  questionLabel: string;
  /** Controlled: the host owns it, so a second badge click on the open question still moves. */
  tab: AuditQuestionDrawerTab;
  onTabChange: (tab: AuditQuestionDrawerTab) => void;
  onClose: () => void;
  /** Read-only relations the question's answer already carries; `links/` returns manual links only. */
  lookupRelations?: UuidableName[];
  lookupModule?: EntityModules;
  /** Migrated audits keep their links listable but read-only. */
  readOnlyLinks?: boolean;
  /** The audit's *entity* uuid, which an action's link resolves against — not its submission or
   * draft. Absent leaves the Actions tab read-only; both audit hosts supply it. */
  entityUuid?: string;
};
